//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { METAL_MAP } from '../const'

export default {
    options: {
        virtualHost: true
    },
    data () {
        return {
            filters: Object.keys(METAL_MAP).map((key) => {
                return {
                    icon: METAL_MAP[key],
                    key
                }
            })
        }
    },
    methods: {
        change (medal) {
            this.$emit('change', medal)
        }
    },
    props: {
        medal: String
    }
}
